import axios from "axios";
import Vue from "vue";
const api = axios.create({
  baseURL: "https://panel.multigraharadhika.co.id/api/",
  // baseURL: "https://mgr123-26334-default-rtdb.firebaseio.com/",
  // baseURL: "https://egriv.com/api/",
  // baseURL: "http://localhost:3000/",
  headers: {
    "X-API-KEY": "mgr-api-10519190",
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  function (config) {
    Vue.prototype.$bus.$emit("loading", true);
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  function (response) {
    Vue.prototype.$bus.$emit("loading", false);
    return response;
  },
  function (error) {
    Vue.prototype.$bus.$emit("loading", false);
    return Promise.reject(error);
  }
);

export default api;
